<mat-toolbar>
  <span class="fill-remaining-space"></span>
  <span>
    @if (isDownload()) {
    <mat-spinner diameter="20"></mat-spinner>
    } @if (!isDownload()) {
    <button
      mat-raised-button
      (click)="exportExcel()"
      [disabled]="!unfilteredDataSource">
      Create Excel Export
    </button>
    }
  </span>
</mat-toolbar>
@if (isDefined()) {
<mat-grid-list
  cols="5"
  rowHeight="4rem">
  <mat-grid-tile>Filter by:</mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field>
      <mat-label>Title</mat-label>
      <input
        matInput
        [(ngModel)]="titleSelect"
        (ngModelChange)="filterData()" />
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field>
      <mat-label>Status</mat-label>
      <mat-select
        [(ngModel)]="statusSelect"
        (selectionChange)="filterData()">
        <mat-option value="">-- Show All --</mat-option>
        <mat-option value="Pending">Pending</mat-option>
        <mat-option value="Settled">Settled</mat-option>
        <mat-option value="Pending & Overdue">Pending & Overdue</mat-option>
        @if (all()) {
        <mat-option value="Finally settled">Finally settled</mat-option>
        }
        <mat-option value="Adjourned">Adjourned</mat-option>
      </mat-select>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field>
      <mat-label>Auditee</mat-label>
      <mat-select
        [(ngModel)]="assessmentSelect"
        (selectionChange)="filterData()">
        <mat-option value="">-- Show All --</mat-option>
        @for (possibleCoordinator of possibleCoordinators; track possibleCoordinator) {
        <mat-option value="{{ possibleCoordinator }}"
          >{{ possibleCoordinator | userName | async }} {{ possibleCoordinator | azureIdStatus | async }}</mat-option
        >
        }
      </mat-select>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field>
      <mat-label>BG</mat-label>
      <mat-select
        [(ngModel)]="bgSelect"
        (selectionChange)="filterData()">
        <mat-option value="">-- Show All --</mat-option>
        @for (possibleBg of possibleBgs; track possibleBg) {
        <mat-option value="{{ possibleBg }}">{{ possibleBg }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field>
      <mat-label>Legal Unit</mat-label>
      <mat-select
        [(ngModel)]="legalUnitSelect"
        (selectionChange)="filterData()">
        <mat-option value="">-- Show All --</mat-option>
        @for (possibleLegalUnit of possibleLegalUnits; track possibleLegalUnit) {
        <mat-option value="{{ possibleLegalUnit }}">{{ possibleLegalUnit }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field>
      <mat-label>Plant</mat-label>
      <mat-select
        [(ngModel)]="plantSelect"
        (selectionChange)="filterData()">
        <mat-option value="">-- Show All --</mat-option>
        @for (possiblePlant of possiblePlants; track possiblePlant) {
        <mat-option value="{{ possiblePlant }}">{{ possiblePlant }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field>
      <mat-label>Category</mat-label>
      <mat-select
        [(ngModel)]="categorySelect"
        (selectionChange)="filterData()">
        <mat-option value="">-- Show All --</mat-option>
        @for (category of categories; track category) {
        <mat-option value="{{ category }}">{{ category }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <button
      mat-raised-button
      (click)="showAll()">
      Reset
    </button>
  </mat-grid-tile>
</mat-grid-list>
}

<table
  mat-table
  [dataSource]="dataSource"
  matSort
  matSortActive="currentDeadlineDate"
  matSortDirection="asc"
  class="mat-elevation-z8"
  aria-describedby="table of all recommendations">
  <!--- Note that these columns can be defined in any order.
  The actual rendered columns are set as a property on the row definition" -->
  <ng-container
    matColumnDef="status"
    class="col-md-4 col-sm-12">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="stateHeader">
      Status
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      {{ recommendation.status }}
    </td>
  </ng-container>

  <ng-container
    matColumnDef="auditDefinition"
    class="col-md-4 col-sm-12">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="auditHeader">
      Audit Dep.
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      {{ recommendation.auditDefinition }}
    </td>
  </ng-container>

  <ng-container
    matColumnDef="assessmentCoordinator"
    class="col-md-4 col-sm-12">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="auditeeHeader">
      Auditee
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      {{ recommendation.assessmentCoordinator | userName: recommendation.assessmentCoordinatorName | async }}
      {{ recommendation.assessmentCoordinator | azureIdStatus | async }}
    </td>
  </ng-container>

  <ng-container matColumnDef="legalUnit">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="luHeader">
      Legal Unit
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      {{ recommendation.legalUnit }}
    </td>
  </ng-container>

  <ng-container matColumnDef="plant">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="plantHeader">
      Plant
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      {{ recommendation.plant }}
    </td>
  </ng-container>

  <ng-container matColumnDef="department">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="bgHeader">
      BG
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      {{ recommendation.department }}
    </td>
  </ng-container>

  <ng-container matColumnDef="settledDateFinally">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="finallySettledHeader">
      Finally Settled
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      {{ recommendation.settledDateFinally | date : 'dd.MM.yyyy' : '+0000' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="currentDeadlineDate">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="deadlineHeader">
      Deadline
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      {{ recommendation.currentDeadlineDate | date : 'dd.MM.yyyy' : '+0000' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="title">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="titleHeader">
      Title
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      {{ recommendation.title }}
    </td>
  </ng-container>

  <ng-container matColumnDef="date_settled">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="settledHeader">
      Date Settled
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      {{ recommendation.date_settled | date : 'dd.MM.yyyy' : '+0000' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="category">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="categoryHeader">
      Category
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      {{ recommendation.category }}
    </td>
  </ng-container>

  <ng-container matColumnDef="remark">
    <th
      mat-header-cell
      *matHeaderCellDef
      id="fileHeader">
      File
    </th>
    <td
      mat-cell
      *matCellDef="let recommendation">
      @if (recommendation.hasFiles) {
      <mat-icon matTooltip="File attached">attachment</mat-icon>
      }
    </td>
  </ng-container>

  <tr
    mat-header-row
    *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    (click)="navigateToRecommendation(row)"
    class="item"></tr>
</table>

@if (!isDefined()) {
<mat-spinner class="spinner" />
}

<mat-paginator
  [pageSizeOptions]="[10, 25, 40]"
  showFirstLastButtons />
